<div class="innerpage-fullwithbanner">
  <h2 class="bighead" *ngIf="prevPage !='Buyer Criteria'">{{userDetailsOutput.FirstName}} {{userDetailsOutput.LastName}}</h2>
  <h2 class="bighead" *ngIf="prevPage =='Buyer Criteria'">Acquisition Criteria</h2>
  <ul class="bread-crumbs">
    <li><a (click)="_validationService.redirect('/')">Home<span>|</span></a></li>
    <li>
      <a (click)="onBreadCrumbClick();">{{prevPage}}<span>|</span></a>
    </li>
    <li *ngIf="prevPage !='Buyer Criteria'">User Detail</li>
    <li *ngIf="prevPage=='Buyer Criteria'">Acquisition Criteria</li>
  </ul>
</div>
<div class="section-margin">
  <div class="container container-lg min-heightcontainer">
    <div class="border-div margin0">

      <div class="tabstyle2 offerdetailstab-padding pos-relative">
        <ul class="switchingproperty margin-bottom-15 offerlistingtab">
          <li [class.active]="activeTab === tab.PersonalInformation" *ngIf="prevPage !='Buyer Criteria'">
            <a (click)="onTabClick(tab.PersonalInformation)">
              Profile
            </a>
          </li>
          <li [class.active]="activeTab === tab.Associations" *ngIf="(permissionService.hasPermission(Modules.ExternalUsers,Actions.AssociationsList)) &&prevPage !='Buyer Criteria'&&User!=null">
            <a (click)="onTabClick(tab.Associations)">
              Associations
            </a>
          </li>
          <li [class.active]="activeTab === tab.Prospects" *ngIf="!IsGuest&&permissionService.hasPermission(Modules.Prospects,Actions.Details)">
            <a (click)="onTabClick(tab.Prospects)">
              Manage Prospects
            </a>
          </li>
          <li [class.active]="activeTab === tab.ActivityLog" *ngIf="permissionService.hasPermission(Modules.ActivityLog,Actions.Listings) &&prevPage !='Buyer Criteria'">
            <a (click)="onTabClick(tab.ActivityLog)">
              Activity Log
            </a>
          </li>
          <li [class.active]="activeTab === tab.InterestCriteria" *ngIf="permissionService.hasPermission(Modules.BuyerCriteria,Actions.Details)&&(userDetailsOutput.UserRole == authService.getUserRoleDescription(this.authService.UserRole.Principal))||(userDetailsOutput.UserRole == authService.getUserRoleDescription(this.authService.UserRole.Principal1031))">
            <a (click)="onTabClick(tab.InterestCriteria)">
              Acquisition Criteria
            </a>
          </li>
        </ul>
      </div>
      <div [hidden]="activeTab !== tab.PersonalInformation">
        <div class="floatinghead clearfix">
          <!--<h2 class="mainhead"><span class="text">Personal Information</span></h2>-->
          <button class="right-btn btn  btn-circle btn-green adduserbtn margin-bottom-15" *ngIf="prevPage!='1031 Inquiries'&&prevPage!='Listing Inquiries'&&permissionService.hasPermission(Modules.ExternalUsers,Actions.Edit)" (click)="editUser();" href="#" placement="left" tooltip="Edit User Info" ng-reflect-tooltip="Edit" ng-reflect-placement="top"><i aria-hidden="true" class="icofont icofont-ui-edit icon"></i></button>
          <!--<button class="right-btn btn-border margin-right-10 btn adduserbtn margin-bottom-15" *ngIf="authService.getUserRoleDescription(this.authService.UserRole.Principal1031)=='Principal+1031'&&userDetailsOutput.Is1031User==true&&prevPage!='1031 Inquiries'&&prevPage!='Listing Inquiries'" (click)="openGrantAccessModal(template,'')">{{accessText}}</button>-->
        </div>
        <div class="leftsideprofile">
          <div class="profilepic">
            <img src="{{userDetailsOutput.ProfilePicPath}}">
          </div>
        </div>
        <div class="rightsideprofile margin-bottom-20">
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">First name</label>
                <h6 class="displayvalue">{{userDetailsOutput.FirstName}}</h6>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Last Name</label>
                <h6 class="displayvalue">{{userDetailsOutput.LastName}}</h6>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Email</label>
                <h6 class="displayvalue truncate-email">{{userDetailsOutput.Email}}</h6>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Phone</label>
                <h6 class="displayvalue">{{userDetailsOutput.Phoneno | phone}}</h6>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Address Line 1</label>
                <h6 class="displayvalue">{{userDetailsOutput.Address1 ? userDetailsOutput.Address1 : '-'}}</h6>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Address Line 2</label>
                <h6 class="displayvalue">{{userDetailsOutput.Address2 ? userDetailsOutput.Address2 :'-'}}</h6>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">State</label>
                <h6 class="displayvalue">{{userDetailsOutput.State ? userDetailsOutput.State :'-'}}</h6>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">City</label>
                <h6 class="displayvalue">{{userDetailsOutput.CityName ? userDetailsOutput.CityName : '-'}}</h6>
              </div>
            </div>

          </div>
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">ZIP</label>
                <h6 class="displayvalue">{{userDetailsOutput.Zip ? userDetailsOutput.Zip :'-'}}</h6>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Role</label>
                <h6 class="displayvalue" *ngIf="userDetailsOutput.Is1031User==true">{{userDetailsOutput.UserRole!='Registration Pending'?'Principal + 1031':'-'}}</h6>
                <h6 class="displayvalue" *ngIf="!userDetailsOutput.Is1031User">{{userDetailsOutput.UserRole!='Registration Pending'?userDetailsOutput.UserRole:'-'}}</h6>

              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">User Status</label>
                <h6 class="displayvalue" [ngClass]="_validationService.applyClass(userDetailsOutput.UserStatus)">{{userDetailsOutput.UserStatus}}</h6>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Company Name</label>
                <h6 class="displayvalue">{{userDetailsOutput.CompanyName?userDetailsOutput.CompanyName:'-'}}</h6>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="border-div margin-top-20 rOLEdIV max-ht-300" *ngIf="IsPrincipal&&permissionService.hasPermission(Modules.ExternalUsers,Actions.PermissionandAccess)">
          <accordion [isAnimated]="true" [isOpen]="true">
            <accordion-group heading="Permissions" class="be-collapse-v2" [isOpen]="open">
              <div class="cf">
                <div class="cf">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="table-fixed table-v2 table-gray-hd margin-top-20">
                      <div class="table-responsive">
                        <table class="table basictable row-border">
                          <tbody>
                            <tr *ngIf="IsPrincipal&&userDetailsOutput.Is1031User==true">
                              <td class="whitespacenowrap invited-user">
                                <span class="blue-text hd3 margin-right-5">1031 Trade</span>
                                <span class="userpermissiontooltip" *ngIf="userDetailsOutput.Is1031RequestSent&&userDetailsOutput.Is1031EnabledId!='1051'" tooltip="User has Requested 1031 Properties Access" placement="right">
                                  <img src="/assets/img/request-clock.svg">
                                </span>
                              </td>
                              <td>
                                <button class="{{userDetailsOutput.Is1031EnabledId=='1051'?'btn principle-revoke-access':'btn principle-grant-access'}}" (click)="grantOrReject1031Access()">{{userDetailsOutput.Is1031EnabledId=='1051'?'Revoke 1031 Properties Access':'Grant 1031 Properties Access'}}</button>
                              </td>
                              <td>
                              </td>
                              <td></td>
                            </tr>
                            <tr *ngIf="IsPrincipal&&IsSeller">
                              <td *ngIf='!userDetailsOutput.IsMyPortfolioEnabled' class="whitespacenowrap invited-user">
                                <span class="hd3 margin-right-5">Seller Dashboard</span>
                                <span class="userpermissiontooltip" *ngIf="!userDetailsOutput.IsSellerDashboardEnabled&&userDetailsOutput.IsSellerDashboardRequested" tooltip="User has Requested Seller Dashboard Access">
                                  <img src="/assets/img/request-clock.svg">
                                </span>
                              <td *ngIf='userDetailsOutput.IsMyPortfolioEnabled' class="whitespacenowrap invited-user">
                                <p *ngIf="userDetailsOutput.Id==null||userDetailsOutput.Id==0||userDetailsOutput.Id==undefined" class="whitespacenowrap">
                                  <span class="hd3 margin-right-5">Seller Dashboard</span>
                                  <span class="userpermissiontooltip" *ngIf="!userDetailsOutput.IsSellerDashboardEnabled&&userDetailsOutput.IsSellerDashboardRequested" tooltip="User has Requested Seller Dashboard Access">
                                    <img src="/assets/img/request-clock.svg">
                                  </span>
                                </p>
                                <p *ngIf="userDetailsOutput.Id>0" class="whitespacenowrap">
                                  <a href="javascript:void(0)" routerLink="/seller/dashboard/{{userDetailsOutput.UserGuid}}" [queryParams]="{ prevroute:'External Users',link:router.url}">
                                    <span class="hd3 margin-right-5">Seller Dashboard</span>
                                  </a>
                                  <span class="userpermissiontooltip" *ngIf="!userDetailsOutput.IsSellerDashboardEnabled&&userDetailsOutput.IsSellerDashboardRequested" tooltip="User has Requested Seller Dashboard Access">
                                    <img src="/assets/img/request-clock.svg">
                                  </span>
                                </p>
                              </td>
                              <td>
                                <button class="{{userDetailsOutput.IsSellerDashboardEnabled?'btn principle-revoke-access':'btn principle-grant-access'}}" (click)="grantSellerDashboardAccess()">{{userDetailsOutput.IsSellerDashboardEnabled?'Revoke Seller Dashboard Access':'Grant Seller Dashboard Access'}}</button>
                              </td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                            </tr>
                            <tr *ngIf="hasMyPortfolioAccess==1&&IsPrincipal">
                              <td *ngIf="!userDetailsOutput.IsMyPortfolioEnabled" class="whitespacenowrap invited-user">
                                <span class="blue-text hd3 margin-right-5">My Portfolio</span>
                                <span class="userpermissiontooltip" *ngIf="userRequestedMyPortfolio" tooltip="{{myPortfolioRequestText}}" placement="right">
                                  <img src="/assets/img/request-clock.svg">
                                </span>
                              </td>
                              <td *ngIf="userDetailsOutput.IsMyPortfolioEnabled" class="whitespacenowrap invited-user">
                                <p *ngIf="userDetailsOutput.Id==null||userDetailsOutput.Id==0||userDetailsOutput.Id==undefined">
                                  <span class="blue-text hd3 margin-right-5">My Portfolio</span>
                                  <span class="userpermissiontooltip" *ngIf="userRequestedMyPortfolio" tooltip="{{myPortfolioRequestText}}" placement="right">
                                    <img src="/assets/img/request-clock.svg">
                                  </span>
                                </p>
                                <p *ngIf="userDetailsOutput.Id>0">
                                  <a href="javascript:void(0)" (click)="onRedirection('MyPortfolio')"><span class="hd3">My Portfolio</span>  </a>
                                  <span class="userpermissiontooltip" *ngIf="userRequestedMyPortfolio" tooltip="{{myPortfolioRequestText}}" placement="right">
                                    <img src="/assets/img/request-clock.svg">
                                  </span>
                                </p>
                              </td>
                              <td>
                                <button class="{{userDetailsOutput.IsMyPortfolioEnabled?'btn principle-revoke-access':'btn principle-grant-access'}}" (click)="ChangeAccessStatus(3)">{{userDetailsOutput.IsMyPortfolioEnabled?'Revoke My Portfolio Access':'Grant My Portfolio Access'}}</button>
                              </td>
                              <td>
                                <button class="{{userDetailsOutput.IsAvailablePropertyAccessEnabled?'btn principle-revoke-access':'btn principle-grant-access'}}" (click)="ChangeAccessStatus(1)">{{userDetailsOutput.IsAvailablePropertyAccessEnabled?'Revoke Available Property Access':'Grant Available Property Access'}}</button>
                              </td>

                              <td>
                                <button class="{{userDetailsOutput.IsOffMarketPropertyAccessEnabled?'btn principle-revoke-access':'btn principle-grant-access'}}" (click)="ChangeAccessStatus(2)">{{userDetailsOutput.IsOffMarketPropertyAccessEnabled?'Revoke Off-Market Property Access':'Grant Off-Market Property Access'}}</button>
                              </td>
                            </tr>
                        </table>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div class="clearfix"></div>
            </accordion-group>
          </accordion>
          <!--<h2 class="mainhead "><span class="text"></span></h2>-->


        </div>
        <div class="border-div margin-top-20  max-ht-300" id="prospects" *ngIf="showSellerData&&IsPrincipal&&prevPage!='1031 Inquiries'&&permissionService.hasPermission(Modules.ExternalUsers,Actions.PermissionandAccess)">
          <div class="margin-top-10">
            <accordion [isAnimated]="true" [isOpen]="openProspects">
              <accordion-group heading="Prospects Access" class="be-collapse-v2" [isOpen]="openProspects">
                <div class="table-fixed table-v2">
                  <div class="table-responsive table-gray-hd margin0">
                    <table class="table basictable margin-top-20">
                      <thead>
                        <tr>
                          <th>Property Name</th>
                          <th>Prospects Access</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let prospects of prosepctsList;let i = index">
                          <td>
                            <p><a class="hd3" href="javascript:void(0);" (click)="viewDetail(prospects.PropertyGuid,'prospect')">{{prospects.PropertyName}}</a></p>
                          </td>
                          <td>
                            <p>
                              <button class="{{prospects.Access==1?'btn principle-revoke-access':'btn principle-grant-access'}}" (click)="grantProspectAccess(GrandOrRevokeProspects,'deletemodal',prospects.Id,prospects.Access)">{{prospects.Access?'Revoke Prospects Tab Access':'Enable Prospects Tab Access'}}</button>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr *ngIf="prosepctsList?.length == 0 ">
                          <td colspan="3" class="odd no-data-available">
                            <div class="nodata">
                              <i class="fa fa-exclamation-triangle icon"></i>
                              <p>No Prospects Available</p>
                            </div>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </accordion-group>
            </accordion>

          </div>
        </div>
        <div class="border-div margin-top-20 max-ht-300" id="1031Dashboard" *ngIf="show1031Exchanges&&IsPrincipal&&permissionService.hasPermission(Modules.ExternalUsers,Actions.PermissionandAccess)">
          <div class="margin-top-10">
            <accordion [isAnimated]="true" [isOpen]="openExchange">
              <accordion-group heading="1031 Dashboard Access" class="be-collapse-v2" [isOpen]="openExchange">
                <div class="table-fixed table-v2">
                  <div class="table-responsive table-gray-hd margin0">
                    <table class="table basictable margin-top-20">
                      <thead>
                        <tr>
                          <th>Exchange ID</th>
                          <th>1031 Dashboard Access</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let exchanges of exchangeList;let i = index">
                          <td>
                            <p><a href="javascript:void(0);" class="hd3" (click)="viewDetail(exchanges.ExchangeGuid,'1031Dasboard')">{{exchanges.ExchangeCode}}</a></p>
                          </td>
                          <td>
                            <p>
                              <button class="{{exchanges.ShowDashboard?'btn principle-revoke-access':'btn principle-grant-access'}}" (click)="Change1031Dashboard(exchanges.Id,exchanges.ShowDashboard)">{{exchanges.ShowDashboard?'Revoke 1031 Dashboard Access':'Grant 1031 Dashboard Access'}}</button>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr *ngIf="exchangeList?.length == 0 ">
                          <td colspan="3" class="odd no-data-available">
                            <div class="nodata">
                              <i class="fa fa-exclamation-triangle icon"></i>
                              <p>No Prospects Available</p>
                            </div>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </accordion-group>
            </accordion>
          </div>
        </div>
        <div>
          <div class="border-div margin-top-20 cf" *ngIf="permissionService.hasPermission(Modules.ExternalUsers,Actions.PermissionandAccess)">
            <div class="margin-top-10">
              <div class="clearfix">
                <h2 class="mainhead mainhead2"><span class="text">Tickers</span></h2>
              </div>
              <div class="table-fixed table-v2">
                <div class="table-responsive table-gray-hd margin0">
                  <table class="table basictable">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Symbol</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of tickers;let i = index">
                        <td>
                          <p class="hd3">{{item.Name}}</p>
                        </td>
                        <td>
                          <p>{{item.Symbol}}</p>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr *ngIf="tickers?.length == 0 ">
                        <td colspan="2" class="odd no-data-available">
                          <div class="nodata">
                            <i class="fa fa-exclamation-triangle icon"></i>
                            <p>No Tickers Available</p>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="userDetailsOutput?.UserRoleId !== 10 && permissionService.hasPermission(Modules.ExternalUsers,Actions.PermissionandAccess)" class="border-div cf margin-top-10">
          <div class="margin-top-10">
            <div class="clearfix">
              <h2 class="mainhead mainhead2"><span class="text">Properties Associated</span></h2>
              <!--<button class="right-btn btn  btn-circle btn-green adduserbtn" href="#" ng-reflect-placement="top" ng-reflect-tooltip="Assign Property" placement="top" tooltip="Assign Property"><i aria-hidden="true" class="icofont icofont-plus icon"></i></button>-->
            </div>
            <h3 class="bluelabel">Sale</h3>
            <!--<h3 class="bluelabel">Sale | <span>1031</span></h3>-->
            <div class="table-fixed table-v2">
              <div class="table-responsive table-gray-hd margin0">
                <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
                  <thead>
                    <tr>
                      <th class="min-width-td">Tenant</th>
                      <th>Broker</th>
                      <th>Property Status</th>
                      <th>Asking Price</th>
                      <th>Credit Rating</th>
                      <th>Cap Rate</th>
                      <th>Remaining Term</th>
                      <th>Lease Structure</th>
                      <th>Area</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let property of propertiesAssociated">
                      <td>
                        <p><a class="hd3" href="#" routerLink="/viewproperty/{{property.Slug?property.Slug:property.Guid}}" [queryParams]="{prevroute:'External User Details',link:router.url}">{{property.PropertyName}}</a></p>

                      </td>
                      <td>
                        <p>{{property.BrokerName ? property.BrokerName : '-'}}</p>
                      </td>
                      <td>
                        <p [ngClass]="{'redtextlabel':(property.PropertyStatus === 'Closed' || property.PropertyStatus === 'Sold'),'greentextlabel':property.PropertyStatus === 'Available','orangetextlabel':property.PropertyStatus === 'Under Contract','not-available':property.PropertyStatus === 'Not Available','Off-Market':property.PropertyStatus === 'Off-Market'}">{{property.PropertyStatus }}</p>
                      </td>
                      <td>
                        <p>{{ property.Price ? (property.Price | currency) :'-'}}</p>
                      </td>
                      <td>
                        <p>{{property.SPRating ? property.SPRating:'-'}}</p>
                      </td>
                      <td>
                        <p *ngIf="!property.CharacteristicsId">{{property.CapRate == null ? '' : property.CapRate +'%' }}</p>
                        <p *ngIf="property.CharacteristicsId">ZCF</p>
                      </td>
                      <td>
                        <p>{{property.RemainingTerm == null ? '' : property.RemainingTerm + ' Months'}}</p>
                      </td>
                      <td>
                        <p>{{property.LeaseStructure ?  property.LeaseStructure:'-'}}</p>
                      </td>
                      <td>
                        <p>{{property.BuildingSize == null ? '' : (property.BuildingSize | number) + 'SQFT' }}</p>
                      </td>

                    </tr>
                  </tbody>
                  <tfoot>
                    <tr *ngIf="propertiesAssociated?.length == 0 ">
                      <td colspan="9" class="odd no-data-available">
                        <div class="nodata">
                          <i class="fa fa-exclamation-triangle icon"></i>
                          <p>No Data Available</p>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>

          <div *ngIf="ShowbrokerRegionalLicenses && brokerRegionalLicenses.length > 0 && permissionService.hasPermission(Modules.ExternalUsers,Actions.PermissionandAccess)">
            <div class="floatinghead clearfix">
              <h2 class="mainhead margin-bottom-30" style="margin-bottom:30px !important"><span class="text">Broker Regional Licenses Details</span></h2>
            </div>
            <div class="table-responsive">
              <table class="table basictable">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>State</th>
                    <th>License No.</th>
                    <th>Expiration Date</th>
                    <th>Default</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let field of brokerRegionalLicenses;let i = index">
                    <td><p>{{i+1}}</p></td>
                    <td>
                      <p>{{field.StateName}}</p>
                    </td>
                    <td>
                      <p>{{field.BrokerLicense}}</p>
                    </td>
                    <td>
                      <p>{{field.ExpiryDate_Date| date:'MM/dd/yyyy' }}</p>
                    </td>
                    <td>
                      <i *ngIf="field.IsDefault == true" class="icon-tick icon" aria-hidden="true"></i>
                      <!--<p>{{field.IsDefault == true ? 'Default' : '' }}</p>-->
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr *ngIf="brokerRegionalLicenses?.length == 0 ">
                    <td colspan="9" class="odd no-data-available">
                      <div class="nodata">
                        <i class="fa fa-exclamation-triangle icon"></i>
                        <p>No Data Available</p>
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

        </div>
      </div>
      <div class="clearfix" *ngIf="activeTab === tab.ActivityLog">
        <div class="col-md-12">
          <app-audit-trail [propertyView]="true" [User]="User" [IsDisplayUser]="1" [previousRoute]="prevPage"></app-audit-trail>
        </div>
      </div>

      <div class="clearfix" *ngIf="activeTab === tab.InterestCriteria&&User!=null">
        <div class="col-md-12">
          <app-add-interest-criteria [IsInitialLoad]="1" [UserId]="currentuserid"></app-add-interest-criteria>
        </div>
      </div>
      <div class="clearfix" *ngIf="activeTab === tab.Prospects">
        <div class="col-md-12">
          <prospect-details [prospectId]="prospectUserId" [source]="'prinicipal-details'" [principalDetails]="userDetailsOutput"></prospect-details>
        </div>
      </div>
      <div class="clearfix" *ngIf="activeTab === tab.Associations">
        <div class="col-md-12">
          <user-associations [CurrentUser]="User" [principalDetails]="userDetailsOutput" [moduleId]="Modules.ExternalUsers"></user-associations>
        </div>
      </div>

      <!--<div class="text-right">
      <button class="btn btn-lg btn-green margin-bottom-30" (click)="viewAuditTrail();">{{viewOrHideLabel}} Activity Log</button>
  </div>-->
    </div>

  </div>

  <!--<div *ngIf="isViewAuditTrail">
      <app-audit-trail [objectId]="auditObjectId" [objectTypeId]="auditObjectTypeId"></app-audit-trail>
  </div>-->
</div>
<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">1031 Access Status</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">
        &times;
      </span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">{{userDetailsOutput.Is1031EnabledId != yesno.Yes ? 'Are you sure you want to grant access to view 1031 properties for this user?' : 'Are you sure you want to restrict this user from viewing 1031 properties?'}}</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="grantOrReject1031Access();modalRef.hide();">Confirm</button>
    </div>
  </div>
</ng-template>
<ng-template #GrandOrRevokeProspects>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Grant or Revoke Prospects Access </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefProspect.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">{{prospectText}}</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefProspect.hide()">Cancel</button>
      <button class="btn btn-lg btn-primary" (click)="ChangeSellerProspectStatus();modalRefProspect.hide();">Yes</button>
    </div>
  </div>
</ng-template>
